// components/Reports/ReportModal.jsx
// components/Reports/ReportModal.jsx
import { useState, forwardRef, useImperativeHandle } from 'react';
import {
  Dialog, DialogTitle, DialogContent, DialogActions,
  Button, Select, MenuItem, TextField
} from '@mui/material';
import { REPORT_REASONS } from './reportReasons';
import { createReport } from '../../api/reports';

const ReportModal = forwardRef((_, ref) => {
  const [open, setOpen] = useState(false);
  const [target, setTarget] = useState({ id: null, type: 'post' });
  const [reason, setReason] = useState('');
  const [customReason, setCustomReason] = useState('');

  /** 부모에서 ref.open(id, type) 호출 */
  useImperativeHandle(ref, () => ({
    open: (id, type) => {
      setTarget({ id, type });
      setReason('');
      setCustomReason('');
      setOpen(true);
    }
  }));

  /** 신고 제출 */
  const handleSubmit = async () => {
    const report_reason = reason === '기타' ? customReason : reason;
    if (!report_reason) return alert('신고 사유를 입력하세요.');

    try {
      await createReport(target.type, target.id, report_reason);
      alert('신고가 접수되었습니다.');
      setOpen(false);
    } catch (err) {
      /* ✅ 서버에서 내려준 메시지가 있으면 그대로 표시 */
      const msg = err.response?.data?.message || '신고 접수 실패';
      alert(msg);
    }
  };

  return (
    <Dialog open={open} onClose={() => setOpen(false)}>
      <DialogTitle>
        {target.type === 'post' ? '게시글 신고' : '댓글 신고'}
      </DialogTitle>

      <DialogContent sx={{ display: 'flex', flexDirection: 'column', gap: 2, mt: 1 }}>
        <Select
          value={reason}
          onChange={e => setReason(e.target.value)}
          displayEmpty
        >
          <MenuItem value="">신고 사유 선택</MenuItem>
          {REPORT_REASONS.map(r => (
            <MenuItem key={r.value} value={r.value}>
              {r.label}
            </MenuItem>
          ))}
        </Select>

        {reason === '기타' && (
          <TextField
            label="상세 사유"
            value={customReason}
            onChange={e => setCustomReason(e.target.value)}
          />
        )}
      </DialogContent>

      <DialogActions>
        <Button onClick={() => setOpen(false)}>취소</Button>
        <Button variant="contained" onClick={handleSubmit}>
          신고
        </Button>
      </DialogActions>
    </Dialog>
  );
});

export default ReportModal;
